<script type="text/ecmascript-6">
    import TileQuestion from "./mixin/TileQuestion.vue";

    export default {
        mixins: [
            TileQuestion
        ],
        props: {
            title: {
                default(){
                    return 'Hardware Knocker';
                }
            },
            component_id: {
                default(){
                    return 'hardware_knocker';
                }
            },
            hardwareColour: {
                required: true
            },
            slab: {
                required: true
            },
            hardwareHandle: {
                required: true
            },
            hardwareSpyhole: {
                required: true
            },
            doorRange: {
                required: true
            },
            hardwareSuite: {
                required: false,
                default(){
                    return '';
                }
            },
            extra_text: {
              default() {
                return '';
              }
            },
        },
        computed: {
            passed_filter(){
                return this.variable_ready(this.hardwareColour, this.hardwareHandle, this.hardwareSpyhole, this.slab, this.doorRange);
            },
            thumbURL(){
                return '/thumb/hardware/';
            },
            url(){
                return '/api/options/' + this.fabricator + '/hardware-knocker?hardware_colour=' + this.hardwareColour
                        + '&hardware_handle=' + this.hardwareHandle
                        + '&hardware_spy_hole=' + this.hardwareSpyhole
                        + '&slab=' + this.slab
                        + '&door_range=' + this.doorRange
                        + '&suite=' + this.hardwareSuite;
            },
            cache_key(){
                return '_' + this.hardwareSuite + '_' + this.hardwareColour + '_' + this.hardwareHandle + '_' + this.hardwareSpyhole + '_' + this.slab + '_' + this.doorRange;
            }
        },
        watch: {
            'hardwareColour': function (val, oldVal) {
                this.update_options();
            },
            'hardwareHandle': function (val, oldVal) {
                this.update_options();
            },
            'hardwareSpyhole': function (val, oldVal) {
                this.update_options();
            },
            'slab': function (val, oldVal) {
                this.update_options();
            },
            'doorRange': function (val, oldVal) {
                this.update_options();
            },
            'hardwareSuite': function (val, oldVal) {
                this.update_options();
            },
        }
    }
</script>
